import { DoubleArrowDownIcon, DoubleArrowUpIcon } from '@radix-ui/react-icons'
import { Dispatch, ReactNode, SetStateAction } from 'react'
import { Button, Grid, Text } from '@radix-ui/themes'

import { VehicleSort, VehicleSortKeys } from './types'

interface Props {
  setSort: Dispatch<SetStateAction<VehicleSort>>
  sort: VehicleSort
}

interface SortButtonProps {
  onClick: (field: VehicleSortKeys) => void
  target: VehicleSortKeys
  sort: VehicleSort
}

const SortButton = ({ target, sort, onClick, children }: SortButtonProps & { children: ReactNode }) => {
  const isActive = target === sort.field
  const icon = sort.order === 'asc' ? <DoubleArrowUpIcon /> : <DoubleArrowDownIcon />

  return (
    <Button onClick={() => onClick(target)} variant={sort.field === target ? 'solid' : 'outline'} color="gray">
      <Text>{children}</Text>
      {isActive && icon}
    </Button>
  )
}

export const VehiclesSortBar = ({ sort, setSort }: Props) => {
  const onClick = (field: VehicleSortKeys) => {
    // if the field is already sorted, toggle the order
    // otherwise, set the field to the new field and order to asc
    setSort((sort) => ({
      order: sort.field === field ? (sort.order === 'desc' ? 'asc' : 'desc') : 'asc',
      field,
    }))
  }

  return (
    <Grid align="center" columns="4" gap="2" my="2">
      <SortButton target="createdAt" {...{ sort, onClick }}>
        Fecha Ingreso
      </SortButton>
      <SortButton target="price" {...{ sort, onClick }}>
        Precio
      </SortButton>
      <SortButton target="odometer" {...{ sort, onClick }}>
        KMs
      </SortButton>
      <SortButton target="year" {...{ sort, onClick }}>
        Año
      </SortButton>
    </Grid>
  )
}
